import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'INSTANCE_ID_KEY',
    stateKey: 'instance_id',
  },
];

export default fields;
